<template>
<div>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div v-if="!isProcessing">
    <DiagCorpHeader
      v-if="!isRendering"
      :corpName="this.corpName"
      :corporateFeatureInfoLabels="this.corporateFeatureInfoLabels"
      :corporateSelectable="isAdmin"
      :manageCorpName="manageCorpName"
      :isAdmin="isAdmin"
      :isDiagAvailablePlan="isDiagAvailablePlan"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    </div>

    <div class="l-contents">
      <h1 class="l-pageTitle">
        <span class="l-pageLabel">人員構成</span>障がい者雇用率
      </h1>

      <!-- タブ表示 -->
      <div class="l-acount-tab">
        <ul>
          <li class="is-current"><a @click="goPages(hrType, 'input')">実績・目標の編集</a></li>
          <li><a @click="goPages(hrType, 'report')">レポート</a></li>
        </ul>
      </div>

      <div class="l-contentsBox">

        <div class="alert-box" v-if="!this.hasCurrentYearAchievementData">
          <p>昨年度の実績を把握するために年度を追加しませんか？</p>
          <div class="btn-create-new_wh" @click="addYear"><a href="#" class="js-add-year-modal-show">年度を追加する</a></div>
        </div>

        <!-- 目標値エラー表示 -->
        <div class="l-contentsSection error" v-if="$v.disabilitiesRate.goalDisabilitiesRate.$invalid">
          <div v-if="$v.disabilitiesRate.goalDisabilitiesRate.$invalid" style="padding-bottom:5px;">
            <span style="color:red; font-size: 1.5rem;margin-left: 20px;">障がい者雇用率（目標）：</span>
            <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.goalDisabilitiesRate.$invalid && !$v.disabilitiesRate.goalDisabilitiesRate.customDoubleNum" validation="customDoubleNum" valueInt="3" valueDouble="1"/>
            <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.goalDisabilitiesRate.$invalid && $v.disabilitiesRate.goalDisabilitiesRate.customDoubleNum && !$v.disabilitiesRate.goalDisabilitiesRate.between" validation="between" valueMin="0" valueMax="100"/>
          </div>
        </div>

        <div class="l-contentsSection">
          <div class="human-capitalt-target-input">
            <label class="human-capitalt-target-input__label">目標値</label>
            <p class="human-capitalt-target-input__text">目標とする数値を入力してください。</p>
              <div class="l-inputAccount w-mini">
              <TextBox v-model.trim="$v.disabilitiesRate.$model.goalDisabilitiesRate" type="text" name="disabilitiesRate.goalDisabilitiesRate" class="u-tac" @input="changeInput()"></TextBox>
              </div>
              <p class="human-capitalt-target-input__text">％</p>
          </div>
        </div>
        <div class="l-contentsSection">
          <p class="l-formGroup__label">実績</p>
          <p class="l-text">それぞれの事業年度における「障害者雇用状況報告書」を元に、障がい者数と障害者雇用率を入力してください。<br><br>
          <strong>（身体）＝⑨（リ）の数（知的）＝⑨（カ）の数<br>（精神）＝⑨（ソ）の数　障害者雇用率＝⑪実雇用率</strong></p>

          <div class="l-contentsTitle is-noicon u-mt30">
            <h2 class="l-contentsTitle__text">{{startYear}}年{{accountMonth}}月期の実績</h2>
          </div>
          <DisabilitiesRateInput
            :disabilitiesRate="disabilitiesRate"
            :num="0"
            @change-disabilities-rate="emitChangeDisabilitiesRate"
            ref="DisabilityRateInput"
          >
          </DisabilitiesRateInput>
        </div> <!-- l-contentsSection -->

        <!-- 昨年度以前の実績 -->
        <div class="l-contentsSection">
          <div class="human-capitalt-data-past-all">
            <button class="link-arrow is-open js-human-capitalt-data-past-all-open" >全て開く</button>
            <button class="link-arrow is-close js-human-capitalt-data-past-all-close" >全て閉じる</button>
          </div>
          <div class="human-capitalt-data-past" ref="header1">
            <div class="human-capitalt-data-past__header" >
              <p class="human-capitalt-data-past__label">{{disabilitiesRate_1.year}}年{{accountMonth}}月期の実績</p>
            </div>
            <div class="human-capitalt-data-past__body" ref="body1">
              <DisabilitiesRateInput
                :disabilitiesRate="disabilitiesRate_1"
                :num="1"
                @change-disabilities-rate="emitChangeDisabilitiesRate"
                ref="DisabilityRateInput1"
              >
              </DisabilitiesRateInput>
            </div>
          </div><!--/human-capitalt-data-past-->
          <div class="human-capitalt-data-past" ref="header2">
            <div class="human-capitalt-data-past__header" >
              <p class="human-capitalt-data-past__label">{{disabilitiesRate_2.year}}年{{accountMonth}}月期の実績</p>
            </div>
            <div class="human-capitalt-data-past__body" ref="body2">
              <DisabilitiesRateInput
                :disabilitiesRate="disabilitiesRate_2"
                :num="2"
                @change-disabilities-rate="emitChangeDisabilitiesRate"
                ref="DisabilityRateInput2"
              >
              </DisabilitiesRateInput>
            </div>
          </div><!--/human-capitalt-data-past-->
          <div class="human-capitalt-data-past" ref="header3">
            <div class="human-capitalt-data-past__header" >
              <p class="human-capitalt-data-past__label">{{disabilitiesRate_3.year}}年{{accountMonth}}月期の実績</p>
            </div>
            <div class="human-capitalt-data-past__body" ref="body3">
              <DisabilitiesRateInput
                :disabilitiesRate="disabilitiesRate_3"
                :num="3"
                @change-disabilities-rate="emitChangeDisabilitiesRate"
                ref="DisabilityRateInput3"
              >
              </DisabilitiesRateInput>
            </div>
          </div><!--/human-capitalt-data-past-->
          <div class="human-capitalt-data-past" ref="header4">
            <div class="human-capitalt-data-past__header" >
              <p class="human-capitalt-data-past__label">{{disabilitiesRate_4.year}}年{{accountMonth}}月期の実績</p>
            </div>
            <div class="human-capitalt-data-past__body" ref="body4">
              <DisabilitiesRateInput
                :disabilitiesRate="disabilitiesRate_4"
                :num="4"
                @change-disabilities-rate="emitChangeDisabilitiesRate"
                ref="DisabilityRateInput4"
              >
              </DisabilitiesRateInput>
            </div>
          </div><!--/human-capitalt-data-past-->
        </div><!--/l-contentsSection-->
        <div class="l-contentsBox__bottom u-tac js-fixedBarBottom-hide">
          <div  ref="savebtn" class="btn-basic is-inlne is-primary"><button class="js-human-capitalt-save-modal-show" @click="save">保存</button></div>
        </div>
      </div> <!-- l-contentsBox end -->

      <!-- footer -->
      <ul class="human-capitalt-localnav">
        <li><a @click="goPages(1, pageType)" class="link-arrow">採用女性労働者割合</a></li>
        <li><a @click="goPages(2, pageType)" class="link-arrow">平均継続勤務年数</a></li>
        <li><a @click="goPages(3, pageType)" class="link-arrow">離職率</a></li>
        <li><a @click="goPages(4, pageType)" class="link-arrow">女性管理職比率</a></li>
        <li><a @click="goPages(5, pageType)" class="link-arrow">平均年齢</a></li>
        <li class="is-current"><a @click="goPages(6, pageType)" class="link-arrow">障がい者雇用率</a></li>
        <li><a @click="goPages(7, pageType)" class="link-arrow">高年齢者雇用率</a></li>
        <li><a @click="goPages(8, pageType)" class="link-arrow">労災発生件数</a></li>
        <li><a @click="goPages(9, pageType)" class="link-arrow">年次有給休暇取得率</a></li>
        <li><a @click="goPages(10, pageType)" class="link-arrow">1月あたりの平均残業時間</a></li>
        <li><a @click="goPages(11, pageType)" class="link-arrow">育児休業取得率</a></li>
        <li><a @click="goPages(12, pageType)" class="link-arrow">介護休業・短時間勤務取得者数</a></li>
        <li><a @click="goPages(13, pageType)" class="link-arrow">年間平均賃金</a></li>
        <li><a @click="goPages(14, pageType)" class="link-arrow">財務情報</a></li>
      </ul>
    </div> <!-- l-contents end -->

    <!-- 年度更新アラート -->
    <div class="default-modal js-add-year-modal"  v-show="this.addYearAlert">
      <div class="default-modal__bg js-default-modal-close"></div>
      <div class="default-modal__content is-mini">
        <div class="default-modal__header">
          <a class="default-modal__close js-default-modal-close" href="#" @click="closeAddYearAlert"></a>
        </div>
        <div class="default-modal__body">
          <div class="l-headding is-blueline">新しい年度（{{this.currentYear}}年{{this.accountMonth}}月期）を作成します。</div>
          <ul class="l-list">
            <li>この操作を行うと最も古い年度「{{this.currentYear-4}}年{{this.accountMonth}}月期の実績」が非表示となります。</li>
            <li>実績が入力されていない新しい年度が追加されるため、カルテに表示されている人的資本に関する情報が全て空白になります。</li>
            <li>この操作はやり直しができません。操作を行う場合は下記のボタンをクリックしてください。</li>
          </ul>

          <div class="default-modal__footer" style="text-align: center;">
            <div class="btn-group">
              <div class="btn-basic is-inlne js-cancel is-middle">
                <button class=" js-default-modal-close" @click="closeAddYearAlert">キャンセル</button>
              </div>
              <div class="btn-basic is-inlne is-primary is-middle"><button class=" js-default-modal-close"  @click="createNewYear">新しい年度を作成する</button></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 保存時のアラート -->
    <div class="default-modal js-human-capitalt-save-modal" v-show="this.alertShow">
      <div class="default-modal__bg js-default-modal-close"></div>
      <div class="default-modal__content is-mini">
        <div class="default-modal__header">
          <a class="default-modal__close js-default-modal-close" @click="close(false)"></a>
        </div>
        <div class="default-modal__body">
          <p class="default-modal-message-text">次は入力した情報をもとに、<br>今後の取り組みを検討してみましょう。</p>
          <div class="u-tac">
            <div class="btn-basic is-inlne is-primary">
              <a @click="closeAndGoPages(true)" class="link-arrow is-report-link">レポートページを確認する</a>
            </div>
          </div>
          <div class="default-modal__footer has-border-top u-tac is-flex">
            <label class="l-checkbox">
              <input type="checkbox" v-model="isNotDisplayed"> 今後表示しない。
            </label>
            <div class="btn-basic-small is-inlne"><button class="js-default-modal-close" @click="close(true)">閉じる</button></div>
          </div>
        </div>
      </div>
    </div>

    <div class="l-fixedBarBottom">
      <div class="is-center">
        <div class="btn-basic is-inlne is-primary js-save"><button class="js-human-capitalt-save-modal-show" @click="save">保存</button></div>
      </div>
    </div>

  </main>

  </div>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import { saveAs } from "file-saver";
import DisabilitiesRateInput from '@/components/parts/human_capital/DisabilitiesRateInput.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import { between } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import constant from '@/const';

export default {
  components: {
    Loading,
    DiagCorpHeader,
    DisabilitiesRateInput,
    TextBox,
    ValidationErrorMessage
  },
  data() {
    return {
      isParamAccess: false,
      isProcessing: false,
      isRendering: false,
      latestDiagResult: {
        diagResultId: null,
        diagCourseId: null,
        title: '',
        courseName: '',
        hasRiskDiagResultItems: [],
        existExpiredUpCloseDiagResult: false,
        isOptionDiag: false,
        diagResultLastUpdateDate: null,
        hasVerifiedItem: false,
        diagResultMonthOverMonth: '',
      },
      isNotDisplayed: false,
      isAdmin: false,
      isDiagAvailablePlan: false,
      isShowTutorial: false,
      scrolled: true,

      startYear: null,
      currentYear: null,
      accountMonth: null,
      guideCode: null,

      disabilitiesRate:{},
      disabilitiesRate_1: {},
      disabilitiesRate_2: {},
      disabilitiesRate_3: {},
      disabilitiesRate_4: {},

      alertShow : false,
      isAnswerChanged: false,
      transitionList: constant.TRANSITION_LIST,
      hrType: 6, // 6:障がい者雇用率
      pageType: 'input',
      hasCurrentYearAchievementData: false,
      addYearAlert: false,
    }
  },

  validations: {
    disabilitiesRate: {
      goalDisabilitiesRate: { 
        between: between(0,100),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,2}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      }
    }
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    diagTitle() {
      return this.$store.dispatch('diag/getTitle');
    },
    progress() {
      return Math.floor((this.latestDiagResult.score / this.latestDiagResult.totalScore) * 100);
    },
    score() {
      return this.$store.getters['diag/getScore'];
    },
    totalScore() {
      return this.$store.getters['diag/getTotalScore'];
    },
    hasRiskDiagResultItemsCount() {
      return this.latestDiagResult.hasRiskDiagResultItems.slice(0, 5);
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
  },
  // corpIdの監視　法人切替時に実行される
  watch: {
    diagResultId() {
      this.$store.dispatch('diag/initEachSearchForm');
    },
  },
  mounted() {
    jQuery(function ($) {
      $(window).on('scroll load', function () {
        // ウィンドウの高さとスクロール量を取得
        var windowHeight = $(window).height();
        var scrollAmount = $(window).scrollTop();
        // '.js-fixedBarBottom-hide' 要素の位置を取得
        if($('.js-fixedBarBottom-hide').length){
          var elementOffset = $('.js-fixedBarBottom-hide').offset().top;
          // ウィンドウ内に要素があるかチェック
          if (scrollAmount + windowHeight > elementOffset) {
              // 要素が見えたら '.l-fixedBarBottom' を非表示にする
              $('.l-fixedBarBottom').removeClass('is-show');
          } else {
              // 要素が見えないときは '.l-fixedBarBottom' を表示する
              $('.l-fixedBarBottom').addClass('is-show');
          }
        }
      });
      $('.human-capitalt-data-past__header').on('click', function(){
        $(this).closest('.human-capitalt-data-past').toggleClass('is-open');
        $(this).closest('.human-capitalt-data-past').find('.human-capitalt-data-past__body').slideToggle(100);
        return false;
      });
      $('.js-human-capitalt-data-past-all-open').on('click', function(){
        $('.human-capitalt-data-past').addClass('is-open');
        $('.human-capitalt-data-past__body').slideDown(100);
      });
      $('.js-human-capitalt-data-past-all-close').on('click', function(){
        $('.human-capitalt-data-past').removeClass('is-open');
        $('.human-capitalt-data-past__body').slideUp(100);
      });
    })
  },
  created: async function () {
//    window.addEventListener("scroll", this.handleScroll);

    this.isRendering = true;
    this.isProcessing = true;

    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isSystemAdmin = authority.isSystemAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.isAdmin = authority.isAdmin;
    this.isNormal = authority.userAuthNo==9;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

    // パラメータのチェック
    await this.checkParams(this.$route.params);

    this.isRendering = false;
    this.isProcessing = false;
　},
  /**
   * 画面遷移前　編集項目確認
   */
  beforeRouteLeave (to, from, next) {
    this.isAnswerChanged = this.isAnswerChanged 
      || this.$refs.DisabilityRateInput.getIsAnswerChanged()
      || this.$refs.DisabilityRateInput1.getIsAnswerChanged()
      || this.$refs.DisabilityRateInput2.getIsAnswerChanged()
      || this.$refs.DisabilityRateInput3.getIsAnswerChanged()
      || this.$refs.DisabilityRateInput4.getIsAnswerChanged()

    if (this.isAnswerChanged) {
      const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？")
      if (answer){
        this.setIsAnswerChanged(false);
        next(answer);
      }
    } else {
      next();
    }
  },
  methods: {
    setIsAnswerChanged(flag){
      let inputArray = [this.$refs.DisabilityRateInput, this.$refs.DisabilityRateInput1, this.$refs.DisabilityRateInput2, this.$refs.DisabilityRateInput3, this.$refs.DisabilityRateInput4 ];
      this.isAnswerChanged = flag;
      for (var i=0;i<5;i++) inputArray[i].setIsAnswerChanged(flag);
    },
    /**
     * 値編集チェック用フラグ
     */
    changeInput(){
      this.isAnswerChanged = true
    },
    // 特殊ダイアログのクローズ
    close(saveFlag){
      if ( saveFlag ) {
        if (this.isNotDisplayed) {
          this.$store.dispatch('auth/setIsShowDiagHumanCapitalInput', false);
          this.$axios.post('/ld/api/user/updateIsShowTutorial', { isShowDiagHumanCapitalInput: this.isNotDisplayed,});
        }
      }
      this.alertShow = false;
    },
    closeAndGoPages(saveFlag) {
      this.close(saveFlag);
      this.goPages(this.hrType, 'report');
    },
    handleScroll() {
      const element = this.$refs.savebtn;
      if (element){
        this.scrolled = window.scrollY > 350 && window.scrollY < element.getBoundingClientRect().top-30;
      }
    },
    emitChangeDisabilitiesRate(param) {
      if (param.num == 0){
        this.disabilitiesRate = param.disabilitiesRate;
      }else if (param.num == 1) {
        this.disabilitiesRate_1 = param.disabilitiesRate;
      }else if (param.num == 2) {
        this.disabilitiesRate_2 = param.disabilitiesRate;
      }else if (param.num == 3) {
        this.disabilitiesRate_3 = param.disabilitiesRate;
      }else if (param.num == 4) {
        this.disabilitiesRate_4 = param.disabilitiesRate;
      }
    },
    /**
     * パラメータチェック
     */
    async checkParams(params) {
      let res = await this.$axios.post('/ld/api/hr/checkParams', {
        corpId: params.corpId,
      });
      if (res.status === 500) {
        // checkParamsでエラーになったときは、正常なcorpIdが引き継がれていなかったということで、人的資本管理TOP画面に遷移する
        let corpListRet = await this.$axios.post('/ld/api/corporate/getClientCorporateList', {});
        if (corpListRet) {
          if ( this.corpId == null ) {
            this.$store.dispatch('diag/setCorpId', corpListRet.data.corporateList[0].corpId);
            this.$store.dispatch('diag/setDiagResultId', null);
            this.$store.dispatch('diag/setDiagResultItemId', null);
          }
          this.$toast.error('企業情報が見つからなかったので、Top画面に戻ります。');
          this.$router.replace({path: '/hr/'+this.corpId+'/topparam'});
        }
      }else{
        if ( this.corpId !== params.corpId ) {
          this.$store.dispatch('diag/setCorpId', params.corpId);
          this.$store.dispatch('diag/setDiagResultId', null);
          this.$store.dispatch('diag/setDiagResultItemId', null);
        }
        await this.getCorporateInfo(this.corpId);
        await this.getHumanCapitalData(this.corpId);
      }
    },
    async getCorporateInfo(corpId) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/hr/getCorporateFeatureInfoLabels', {
          corpId: corpId,
        });
        if (res.status == 200) {
          this.$store.dispatch('diag/setCorpName', res.data.corporateName);
          this.$store.dispatch('diag/setCorporateFeatureInfoLabels',  res.data.corporateFeatureInfoLabels);
        }else{
          this.$toast.error(res.data.message);
        }
      }
    },
    /**
     * 必要な女性管理職比率情報を取得する
     */
    async getHumanCapitalData(corpId) {
      if ( corpId != null ) {
        let res = await this.$axios.post('/ld/api/hr/getHumanCapitalData', {corpId: this.corpId, hrType: this.hrType});
        if (res.status === 200) {
          this.startYear = res.data.inputForm.startYear;
          this.currentYear = res.data.inputForm.currentYear;
          this.accountMonth = res.data.inputForm.accountMonth;

          this.disabilitiesRate   = res.data.inputForm.disabilitiesRates[0];
          this.disabilitiesRate_1 = res.data.inputForm.disabilitiesRates[1];
          this.disabilitiesRate_2 = res.data.inputForm.disabilitiesRates[2];
          this.disabilitiesRate_3 = res.data.inputForm.disabilitiesRates[3];
          this.disabilitiesRate_4 = res.data.inputForm.disabilitiesRates[4];

          this.guideCode = res.data.inputForm.guideCode;
          this.hasCurrentYearAchievementData = res.data.inputForm.hasCurrentYearAchievementData;
        }else{
          // error
          this.isProcessing = false;
          this.$router.replace({path: '/hr/'+this.corpId+'/topparam'});
        }
      }
      return corpId;
    },
    /**
     * 保存処理
     */
    async save() {
      var elmArr = [this.$refs.DisabilityRateInput, this.$refs.DisabilityRateInput1, this.$refs.DisabilityRateInput2, this.$refs.DisabilityRateInput3, this.$refs.DisabilityRateInput4];
      // 具体的なアクションの編集モードをfalseにする
      for(let i=0;i<5;i++) elmArr[i].editMode(false);

      if (this.isValid()) {
        this.isProcessing = true;

        var inputArr = [ this.disabilitiesRate, this.disabilitiesRate_1, this.disabilitiesRate_2, this.disabilitiesRate_3, this.disabilitiesRate_4];
        // 具体的なアクション項目の制御のため、空白のときはnullにする
        for(let i=0;i<5;i++){
          if(inputArr[i].actionMemo!=null && inputArr[i].actionMemo.length == 0) inputArr[i].actionMemo=null;
        }

        let res = await this.$axios.post('/ld/api/hr/saveDisabilitiesRate', {
          disabilitiesRates: inputArr
        });
        if (res.status === 200) {
          this.$toast.info('登録が完了しました');
          this.alertShow = this.$store.getters['auth/getUser'].tutorial.isShowDiagHumanCapitalInput;
          this.setIsAnswerChanged(false);
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }else {
        this.$toast.error('入力データが不正です。');
      }
    },
    /**
     * 年度毎　財務情報の入力エラーを含めた入力エラーチェック
     */
    isValid() {
      this.$v.$touch();
      let disabilitiesRateValidate = true;
      this.$refs['DisabilityRateInput'].$v.$touch();
      this.$refs['DisabilityRateInput1'].$v.$touch();
      this.$refs['DisabilityRateInput2'].$v.$touch();
      this.$refs['DisabilityRateInput3'].$v.$touch();
      this.$refs['DisabilityRateInput4'].$v.$touch();
      disabilitiesRateValidate = !this.$refs['DisabilityRateInput'].$v.$invalid
        && !this.$refs['DisabilityRateInput1'].$v.$invalid
        && !this.$refs['DisabilityRateInput2'].$v.$invalid
        && !this.$refs['DisabilityRateInput3'].$v.$invalid
        && !this.$refs['DisabilityRateInput4'].$v.$invalid;
      return !this.$v.$invalid && disabilitiesRateValidate
    },
    /**
     * 最新年度以外の入力部の表示・非表示処理(まとめて処理)
     */
    allOpen(flg) {
      const headerElmArry = [ this.$refs.header1, this.$refs.header2, this.$refs.header3, this.$refs.header4 ];
      for (let i = 0 ; i < headerElmArry.length ; i++){
        if ( (!headerElmArry[i].classList.contains("is-open") && flg) || (headerElmArry[i].classList.contains("is-open") && !flg) ){
          this.toggle(i+1);
        } 
      }
    },
    /**
     * 最新年度以外の入力部の表示・非表示処理
     */
    toggle(num){
      const headerElmArry = [ this.$refs.header1, this.$refs.header2, this.$refs.header3, this.$refs.header4 ];
      const bodyElmArry = [ this.$refs.body1, this.$refs.body2, this.$refs.body3, this.$refs.body4 ];
      const headerElm = headerElmArry[num-1];
      const bodyElm   = bodyElmArry[num-1];
　　　//トグルでクラスが切り替わる
      headerElm.classList.toggle("is-open");
      if(headerElm.classList.contains("is-open")){
        //要素の高さをstyle属性で付与
        bodyElm.style.height = bodyElm.scrollHeight + 'px';
      }else{
      //要素の高さを0にする
        bodyElm.style.height = 0;
      }
    },
    // 遷移関数
    goPages(num, type) {
      this.$router.replace({path: '/hr/'+this.corpId + '/' + this.transitionList[num] + '_' + type});
    },
    /**
     * 年度追加処理
     */
    async createNewYear() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/hr/createNewYear', { corpId: this.corpId, year: this.currentYear });
      if ( res.status == 200 ) {
          this.$toast.info('登録が完了しました');
        // 人的資本データの取得
        let res = await this.$axios.post('/ld/api/hr/getHumanCapitalData', {corpId: this.corpId, hrType: this.hrType});
        if (res.status === 200) {
          this.startYear = res.data.inputForm.startYear;
          this.currentYear = res.data.inputForm.currentYear;
          this.accountMonth = res.data.inputForm.accountMonth;

          this.disabilitiesRate   = res.data.inputForm.disabilitiesRates[0];
          this.disabilitiesRate_1 = res.data.inputForm.disabilitiesRates[1];
          this.disabilitiesRate_2 = res.data.inputForm.disabilitiesRates[2];
          this.disabilitiesRate_3 = res.data.inputForm.disabilitiesRates[3];
          this.disabilitiesRate_4 = res.data.inputForm.disabilitiesRates[4];

          this.guideCode = res.data.inputForm.guideCode;
          this.hasCurrentYearAchievementData = res.data.inputForm.hasCurrentYearAchievementData;
        }else{
          // error
          this.$toast.error(res.data.message);
        }
      } else {
        this.$toast.error(res.data.message);
      }
      // モーダル画面を閉じる
      this.closeAddYearAlert();
      this.isProcessing = false;
    },
    closeAddYearAlert() {
      this.addYearAlert = false;
    },
    addYear() {
      this.addYearAlert = true;
    },
    // 特徴データを取得して設定
    async getCorporateFeatureInfoLabels(corpId) {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateFeatureInfoLabels', {
        corpId: corpId,
      });
      if (res) {
        this.$store.dispatch('diag/setCorporateFeatureInfoLabels', res.data.corporateFeatureInfoLabels);
      }
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);

      this.$router.replace({name: 'hr-disabilities-rate-input', params: { corpId: this.corpId }});
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    showTutorialModal(value) {
      this.isShowTutorial = value;
    },
  }
}
</script>

<style scoped>
.diagtitlechange-fade-enter-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-leave-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.diagtitlechange-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.tutorialmodal-fade-enter-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-leave-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.tutorialmodal-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
